// src/AppRoutes.js
import AboutPage from "Components/AboutPage/AboutPage";
import ForgotPassword from "Components/ForgotPassword/ForgotPassword";
import ProtectedRoute from "Components/ProtectedRoute";
import { useEffect, useState } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import CourseDetailsPage from "./Components/CourseDetailsPage/CourseDetailsPage";
import RoleBasedDashboard from "./Components/Dashboard/RoleBasedDashboard";
import PlacementTestMain from "./Components/Dashboard/StudentDashboard/PlacementTestMain";
import PlacementTestRules from "./Components/Dashboard/StudentDashboard/PlacementTestRules";
import NotFoundPage from "./Components/Error/NotFoundPage";
import Home from "./Components/Home/Home";
import GermanLanguagePage from "./Components/GermanLanguagePage/GermanLanguagePage";
import LoadingSpinner from "./Components/Loader/LoadingSpinner";
import Login from "./Components/Login/Login";
import MainLayout from "./Components/MainLayout/MainLayout";
import ContactPage from "./Components/Contact/ContactPage";
import TeamPage from "./Components/TeamPage/TeamPage";
import TeacherDetailsPage from "./Components/TeacherDetailsPage/TeacherDetailsPage";
import EventsPage from "./Components/EventsPage/EventsPage";
import GraduateJobSearchPage from "./Components/Services/GraduateJobSearch/GraduateJobSearchPage";
import CorporateTrainingPage from "./Components/Services/CorporateTraining/CorporateTrainingPage";
import CorporateRecruitmentPage from "./Components/Services/CorporateRecruitment/CorporateRecruitmentPage";
import SignUp from "./Components/SignUp/Signup";
import CompleteGuestRegistration from "./Components/SignUp/CompleteGuestRegistration";
import TransitionWrapper from "./Components/TransitionWrapper/TransitionWrapper";
import Verification from "./Components/Verfication/Verification";
import UniversityTrainingPage from "Components/UniversityTraining/UniversityTrainingPage";
import ConsultingPage from "Components/ConsultingPage/ConsultingPage";
import AdminRoutes from "./pages/admin/adminRoutes";
import StudentRoutes from "./pages/student/studentRoutes";
import TeacherRoutes from "./pages/teacher/teacherRoutes";
import ConsultantRoutes from "./pages/consultant/consultantRoutes";
import AusbildungRoutes from "./pages/ausbildung/ausbildungRoutes";
import PublicAusbildungCvPage from "./pages/ausbildung/PublicAusbildungCvPage";
import PublicAusbildungRoomPage from "./pages/ausbildung/PublicAusbildungRoomPage";
import PrivacyPolicyPage from "./Components/PrivacyPolicy/PrivacyPolicyPage";
import ImprintPage from "./Components/Imprint/ImprintPage";
import PaymentReturnPage from "./Components/Payment/PaymentReturnPage";
import SiteFeedbackPage from "./Components/SiteFeedback/SiteFeedbackPage";
import CourseInterestPage from "./Components/CourseInterest/CourseInterestPage";

const AppRoutes = ({
  isLoggedIn,
  profileName,
  roleName,
  roleNames,
  handleLogout,
}) => {
  const location = useLocation();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => setLoading(false), 400);
    return () => clearTimeout(timer);
  }, [location.pathname]);
  return (
    <>
      <LoadingSpinner loading={loading} />
      <TransitionWrapper>
        <Routes>
          <Route path="/ausbildung/cv/:token" element={<PublicAusbildungCvPage />} />
          <Route path="/ausbildung/rooms/share/:token" element={<PublicAusbildungRoomPage />} />
          <Route
            path="/"
            element={
              <MainLayout
                isLoggedIn={isLoggedIn}
                profileName={profileName}
                onLogout={handleLogout}
              >
                <Home />
              </MainLayout>
            }
          />
          <Route path="/rate-website" element={<MainLayout isLoggedIn={isLoggedIn} profileName={profileName} onLogout={handleLogout}><SiteFeedbackPage mode="rating" /></MainLayout>} />
          <Route path="/technical-support" element={<MainLayout isLoggedIn={isLoggedIn} profileName={profileName} onLogout={handleLogout}><SiteFeedbackPage mode="problem" /></MainLayout>} />
          <Route
            path="/courses/:teacherCourseId"
            element={
              <MainLayout
                isLoggedIn={isLoggedIn}
                profileName={profileName}
                onLogout={handleLogout}
              >
                <CourseDetailsPage />
              </MainLayout>
            }
          />
          <Route
            path="/german-language"
            element={
              <MainLayout
                isLoggedIn={isLoggedIn}
                profileName={profileName}
                onLogout={handleLogout}
              >
                <GermanLanguagePage />
              </MainLayout>
            }
          />
          <Route path="/course-interest/:slug" element={<MainLayout isLoggedIn={isLoggedIn} profileName={profileName} onLogout={handleLogout}><CourseInterestPage /></MainLayout>} />
          <Route
            path="/university-training"
            element={
              <MainLayout
                isLoggedIn={isLoggedIn}
                profileName={profileName}
                onLogout={handleLogout}
              >
                <UniversityTrainingPage />
              </MainLayout>
            }
          />
          <Route
            path="/university-admission"
            element={
              <MainLayout
                isLoggedIn={isLoggedIn}
                profileName={profileName}
                onLogout={handleLogout}
              >
                <UniversityTrainingPage mode="university" />
              </MainLayout>
            }
          />
          <Route
            path="/ausbildung"
            element={
              <MainLayout
                isLoggedIn={isLoggedIn}
                profileName={profileName}
                onLogout={handleLogout}
              >
                <UniversityTrainingPage mode="ausbildung" />
              </MainLayout>
            }
          />
          <Route
            path="/graduate-job-search"
            element={
              <MainLayout
                isLoggedIn={isLoggedIn}
                profileName={profileName}
                onLogout={handleLogout}
              >
                <GraduateJobSearchPage />
              </MainLayout>
            }
          />
          <Route
            path="/corporate-language-cultural-training"
            element={
              <MainLayout
                isLoggedIn={isLoggedIn}
                profileName={profileName}
                onLogout={handleLogout}
              >
                <CorporateTrainingPage />
              </MainLayout>
            }
          />
          <Route
            path="/corporate-recruitment"
            element={
              <MainLayout
                isLoggedIn={isLoggedIn}
                profileName={profileName}
                onLogout={handleLogout}
              >
                <CorporateRecruitmentPage />
              </MainLayout>
            }
          />
          <Route
            path="/career-consultation"
            element={
              <MainLayout
                isLoggedIn={isLoggedIn}
                profileName={profileName}
                onLogout={handleLogout}
              >
                <ConsultingPage />
              </MainLayout>
            }
          />
          <Route
            path="/events"
            element={
              <MainLayout
                isLoggedIn={isLoggedIn}
                profileName={profileName}
                onLogout={handleLogout}
              >
                <EventsPage />
              </MainLayout>
            }
          />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/complete-guest-registration" element={<CompleteGuestRegistration />} />
          <Route path="/signup/complete-placement" element={<CompleteGuestRegistration />} />
          <Route path="/verify" element={<Verification />} />
          <Route
            path="/about-us"
            element={
              <MainLayout
                isLoggedIn={isLoggedIn}
                profileName={profileName}
                onLogout={handleLogout}
              >
                <AboutPage />
              </MainLayout>
            }
          />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route
            path="/contact"
            element={
              <MainLayout
                isLoggedIn={isLoggedIn}
                profileName={profileName}
                onLogout={handleLogout}
              >
                <ContactPage />
              </MainLayout>
            }
          />
          <Route
            path="/privacy-policy"
            element={
              <MainLayout
                isLoggedIn={isLoggedIn}
                profileName={profileName}
                onLogout={handleLogout}
              >
                <PrivacyPolicyPage />
              </MainLayout>
            }
          />
          <Route
            path="/imprint"
            element={
              <MainLayout
                isLoggedIn={isLoggedIn}
                profileName={profileName}
                onLogout={handleLogout}
              >
                <ImprintPage />
              </MainLayout>
            }
          />
          <Route
            path="/team"
            element={
              <MainLayout
                isLoggedIn={isLoggedIn}
                profileName={profileName}
                onLogout={handleLogout}
              >
                <TeamPage />
              </MainLayout>
            }
          />
          <Route
            path="/teachers/:businessKey"
            element={
              <MainLayout
                isLoggedIn={isLoggedIn}
                profileName={profileName}
                onLogout={handleLogout}
              >
                <TeacherDetailsPage />
              </MainLayout>
            }
          />
          <Route
            path="/dashboard"
            element={
              <RoleBasedDashboard
                roleName={roleName}
                profileName={profileName}
              />
            }
          />
          <Route path="/placement/rules" element={<PlacementTestRules />} />
          <Route path="/placement/test" element={<PlacementTestMain />} />
          <Route
            path="/payment/success"
            element={
              <MainLayout
                isLoggedIn={isLoggedIn}
                profileName={profileName}
                onLogout={handleLogout}
              >
                <PaymentReturnPage resultType="success" />
              </MainLayout>
            }
          />
          <Route
            path="/payment/failure"
            element={
              <MainLayout
                isLoggedIn={isLoggedIn}
                profileName={profileName}
                onLogout={handleLogout}
              >
                <PaymentReturnPage resultType="failure" />
              </MainLayout>
            }
          />

          {TeacherRoutes(roleName, roleNames)}
          {ConsultantRoutes(roleName, roleNames)}
          {AusbildungRoutes(roleName, roleNames)}
          {AdminRoutes(roleName, roleNames)}

          <Route
            path="/*"
            element={
              <ProtectedRoute
                element={<StudentRoutes />}
                allowedRoles={["STUDENT"]}
                userRoles={roleNames || [roleName]}
              />
            }
          />

          <Route path="*" element={<Navigate to="/404" replace />} />
          <Route path="/404" element={<NotFoundPage />} />
        </Routes>
      </TransitionWrapper>
    </>
  );
};

export default AppRoutes;
